import React from 'react';
import { Link } from 'react-router-dom';
import LegalLayout, { LegalSection, LegalDisclaimer, LegalLastUpdated } from '../LegalLayout';
import { APP_NAME } from '../../config/branding';

export default function FairUsePage() {
  return (
    <LegalLayout
      title="Fair Use Policy"
      subtitle={`Guidelines for sharing, referencing, and reusing content on ${APP_NAME}.`}
    >
      <LegalLastUpdated />

      <LegalSection title="Overview">
        <p>
          {APP_NAME} encourages knowledge sharing and thoughtful discussion. This Fair Use Policy explains how members
          should handle content they did not create — including quotations, screenshots, excerpts, links, and media —
          while respecting creators&apos; rights.
        </p>
      </LegalSection>

      <LegalSection title="Your original work">
        <p>
          You may share original text, images, videos, and documents you own or have permission to distribute. By posting,
          you confirm you have the necessary rights. Do not upload confidential material you are not authorized to disclose.
        </p>
      </LegalSection>

      <LegalSection title="Referencing others&apos; work">
        <ul>
          <li><strong>Attribute sources</strong> — name the creator, publication, or platform where possible</li>
          <li><strong>Use excerpts thoughtfully</strong> — quote only what is needed for commentary, criticism, education, or discussion</li>
          <li><strong>Link when you can</strong> — prefer linking to the original rather than re-hosting full works</li>
          <li><strong>Respect takedown requests</strong> — if a rights holder contacts us with a valid claim, we may remove content</li>
        </ul>
      </LegalSection>

      <LegalSection title="What is not fair use on the platform">
        <ul>
          <li>Uploading full copyrighted books, films, music albums, or paid course materials without authorization</li>
          <li>Reposting large portions of news articles or blogs without attribution or beyond reasonable quotation</li>
          <li>Using others&apos; profile photos or identity elements to impersonate them</li>
          <li>Commercial redistribution of member content without explicit permission</li>
        </ul>
      </LegalSection>

      <LegalSection title="Fair use and local law">
        <p>
          &quot;Fair use&quot; (United States) and similar doctrines (e.g., &quot;fair dealing&quot; in other countries)
          depend on context: purpose, amount used, nature of the work, and market effect. {APP_NAME} does not provide
          legal advice. When in doubt, seek permission from the rights holder or consult qualified counsel. See{' '}
          <Link to="/legal/regional" className="legal-inline-link">Regional Compliance</Link> for jurisdiction-specific notes.
        </p>
      </LegalSection>

      <LegalSection title="Copyright complaints">
        <p>
          Rights holders who believe content on {APP_NAME} infringes copyright may contact{' '}
          {/* <a href={`mailto:${SUPPORT_EMAIL}`} className="legal-inline-link">{SUPPORT_EMAIL}</a> with: */}
          <Link to="/contact" className="legal-inline-link">Contact</Link> form with:
        </p>
        <ul>
          <li>Identification of the copyrighted work</li>
          <li>URL or description of the infringing material on {APP_NAME}</li>
          <li>Your contact information and a good-faith statement of authorization</li>
          <li>A statement that the information is accurate under penalty of perjury (where applicable)</li>
        </ul>
        <p>We respond to valid notices and may remove or disable access to disputed material.</p>
      </LegalSection>

      <LegalDisclaimer />
    </LegalLayout>
  );
}
